import { Component, Prop, Vue } from 'vue-property-decorator';
import AsideMenuList from '@/components/AsideMenuList';
import { Menu } from '@/models';

// https://vuejs.org/v2/guide/components-edge-cases.html#Recursive-Components
@Component({
    components: { AsideMenuList },
})
export default class AsideMenuItem extends Vue {

    private isDropdownActive = false;
    private updateMark = true;

    @Prop({ default: undefined }) private readonly item!: Menu;

    get componentAs(): string {
        return this.item.to !== undefined ? 'router-link' : 'a';
    }

    get hasDropdown(): boolean {
        return this.item.menu !== undefined;
    }

    get dropdownIcon(): string {
        return this.isDropdownActive ? 'minus' : 'plus';
    }

    get itemTo(): string | undefined {
        return this.item.to;
    }

    get itemHref(): string | undefined {
        return this.item.href;
    }

    get isActive(): boolean {
        return this.item.isActive || false;
    }

    private onSelectMenu(): void {
        this.$emit('onSelectMenu', this.item);
        if (this.hasDropdown) {
            this.isDropdownActive = !this.isDropdownActive;
        }
    }

}